
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.352 7.523a4.07 4.07 0 01-.907.82 5.283 5.283 0 01-1.101.54l-.32-.89c.52-.183.986-.477 1.398-.884L.414 4.83v-.75L5.43 1.765a3.298 3.298 0 00-.594-.485A4.065 4.065 0 004.03.86l.36-.867c.385.151.731.33 1.039.54.312.208.627.476.945.804L9.055.094l.46 1.008-2.53 1.164c.223.343.385.69.484 1.039.099.343.148.713.148 1.11 0 .4-.057.783-.172 1.147-.11.36-.263.709-.46 1.047l2.53 1.157-.46 1.007-2.703-1.25zM6.047 6.18a3.5 3.5 0 00.375-.844c.083-.281.125-.583.125-.906a3.04 3.04 0 00-.125-.883 3.629 3.629 0 00-.367-.852L2.14 4.438 6.047 6.18z","fill":"currentColor"}})])
          )
        }
      }
    